import Cookies from "js-cookie";

class JwtToken {
    domain = "";

    constructor() {
        // Because the vue-auth use domain has prefix dot (.) before domain.
        // So, we need to custom same it
        this.domain = "." + window.location.hostname;
    }

    /**
     * @description To check a token is exist
     * @returns boolean
     */
    isHasToken() {
        return this.getToken() ? true : false;
    }

    /**
     * @description To response time for expires in
     * @param {"limit" | "forever"} type 
     * @returns Number
     */
    getExpires(type = "") {
        const limitTime = 60;
        const foreverTime = 60 * 24 * 30;
        // Maximum of limit is 1 hour
        if(type === "limit") {
            return limitTime;
        }
        
        // Maximum of forever is 1 month
        if(type === "forever") {
            return foreverTime;
        }

        // default
        return limitTime;
    }

    /**
     * @description Check the token should be remember
     * @returns Boolean
     */
    isRememberToken() {
        return Cookies.get("rememberMe") == 'true';
    }

    /**
     * @description Set the new token to cookie with
     *
     * @param {String} token The access token
     * @param {Number} expires_in The expires in time (minutes unit)
     * @returns void
     */
    setToken(token = null, expires_in = null) {
        const time = expires_in ? new Date(new Date().getTime() + expires_in * 60 * 1000) : null;        
        Cookies.set("laravel-token", token, {
            domain: this.domain,
            expires: time
        });
    }

    /**
     * @description To get token in cookie
     * @returns String
     */
    getToken() {
        return Cookies.get("laravel-token");
    }

    /**
     * @description To remove token in cookie
     * @returns void
     */
    removeToken() {
        return Cookies.remove("laravel-token", {
            domain: this.domain
        });
    }
}

const jwtToken = new JwtToken();

export default jwtToken;



// WEBPACK FOOTER //
// ./src/core/helpers/jwtToken.js